import { gql } from '@apollo/client'

export const KEYWORDIFY_MUTATION = gql`
  mutation keywordify($attributes: KeywordifyInput!) {
    keywordify(attributes: $attributes) {
      id
      response
    }
  }
`
